import type { ComprehensiveScenario } from '@/types/scenarios';

/**
 * Derives permission booleans from a scenario's `currentUserPermission` field.
 *
 * Permission hierarchy:  owner > edit > comment > view
 */
export function useScenarioPermission(scenario: ComprehensiveScenario | undefined) {
  const permission = scenario?.currentUserPermission;
  return {
    permission,
    isOwner: permission === 'owner',
    canEdit: permission === 'owner' || permission === 'edit',
    canComment: permission === 'owner' || permission === 'edit' || permission === 'comment',
    canView: permission != null,
  };
}
